import { DeleteButton } from "@components/buttons/delete";
import { SHStack, SHTypography } from "@components/design-systems";
import { useFeeCalculatorEditFamilyMember } from "@hooks/useFeeCalculatorEditFamilyMember";
import { FamilyMemberAccountDTO } from "@models/platform-analysis/entities/steps/fee";
import { FeeCalculatorRenderFieldType } from "@models/platform-analysis/enums/fee/renderFieldType";
import { FeeCalculatorNumericInputController } from "../../../../controllers/numeric-input-controller";

type Props = {
  account: FamilyMemberAccountDTO;
  title?: string;
  itemIndex: number;
  memberIndex: number;
  disabled?: boolean;
  onRemove?: () => void;
  onChange?: (value: number) => void;
};

export const FamilyMemberAccountBalance = ({
  account,
  title,
  itemIndex,
  memberIndex,
  disabled,
  onRemove,
}: Props) => {
  const { accountFieldPath, reCalculateTotalBalance } =
    useFeeCalculatorEditFamilyMember({
      memberIndex,
      accountIndex: account.accountIndex,
    });

  const handleOnBalanceChange = () => {
    reCalculateTotalBalance();
  };

  const handleOnRemoveAccount = () => {
    onRemove?.();
    reCalculateTotalBalance();
  };

  return (
    <SHStack marginTop={itemIndex === 0 ? 0 : 3}>
      <SHTypography colorVariant={"third"} variant="subtitle2">
        {title} {itemIndex + 1}
      </SHTypography>
      <SHStack direction={"row"} alignItems={"center"} spacing={2}>
        <FeeCalculatorNumericInputController
          resetOnUnmount={false}
          fieldType={FeeCalculatorRenderFieldType.CurrencyInput}
          fieldPath={accountFieldPath}
          disabled={disabled}
          convertToNumericString={false}
          handleOnValueChange={handleOnBalanceChange}
        />
        <DeleteButton onClick={handleOnRemoveAccount} disabled={disabled} />
      </SHStack>
    </SHStack>
  );
};
